import * as React from "react";
function SvgChartUp(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3 5.5a.5.5 0 111 0v9.887l3.668-3.26.393-.35.33.41 1.673 2.093 7.607-6.656a.5.5 0 11.658.752l-8 7-.393.344-.326-.408-1.671-2.088L4 16.724V18h16.5a.5.5 0 010 1h-17a.5.5 0 01-.5-.5v-1.997V5.5zm12.5.5a.5.5 0 000 1H19v3.5a.5.5 0 001 0V6h-4.5z" /></svg>;
}
const ForwardRef = React.forwardRef(SvgChartUp);
export default ForwardRef;